// Generated from the canonical content before dev/build; contains no page bodies.
import catalog from "@/data/routing-catalog.json";
import { t } from "@/lib/content";
import type { Lang } from "@/lib/types";

const LEGACY_SERVICE_SLUGS: Record<string, string> = {
  webbdesign: "web-design",
  "website-design": "web-design",
  "lead-generation": "lead-gen",
  advertising: "sem",
  sem: "sem",
  branding: "branding",
  "ai-automatisering": "ai-automation",
};

export function getServiceRouteByTag(tag: string) {
  return catalog.services.find((service) => service.tag === tag);
}

export function getServiceRouteBySlug(slug: string, lang: Lang = "en") {
  return catalog.services.find((service) => t(service.slug, lang) === slug)
    ?? getServiceRouteByTag(LEGACY_SERVICE_SLUGS[slug]);
}

export function getProjectRouteBySlug(slug: string, lang: Lang = "sv") {
  return catalog.projects.find((project) => t(project.slug, lang) === slug);
}

export function getHubspotBreadcrumbCopy(lang: Lang) {
  return t(catalog.hubspotBreadcrumb, lang);
}

export const SERVICE_ROUTES = catalog.services;
